import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../Assets/images/logo.png";
import CongratulationIcon from "../../Assets/svgs/CongratulationIcon";
import { Loader } from "../../Common/Loader";
import SubscriptionPlanCard from "../../Common/SubscriptionPlanCard";
import { getUserPlan } from "../../Redux/Slice/Plans/GetUserPlanSlice";
import "../../Style/scss/pages/dashboard.scss";

const StartFreeTrial = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const redirectUrl = location?.state?.redirectUrl;

  const [isLoading, setIsLoading] = useState(false);
  const [trialPlanData, setTrialPlanData] = useState({});

  const handleContinue = () => {
    navigate("/addPayment", {
      state: {
        isRedirectedFromSignup: true,
        redirectUrl,
      },
    });
  };

  const getTrialPlanData = async () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    setIsLoading(true);
    try {
      const result = await dispatch(getUserPlan(userData?.customer?.id));
      if (
        getUserPlan?.fulfilled?.match(result) &&
        result?.payload?.success === true
      ) {
        setTrialPlanData(result?.payload?.data);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTrialPlanData();
  }, []);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <section className="layoutContainer layoutContainer--full">
        <div className="layoutGrid">
          <div className="page page--loginOtp">
            <div className="page__head">
              <div className="page__head__logo">
                <img src={Logo} alt="Logo | Vox App" />
              </div>
            </div>
            <div className="page__body">
              <div className="plansWrap plansWrap--congratulations">
                <div className="plansWrap__head">
                  <div className="icon">
                    <CongratulationIcon />
                  </div>
                  <h1 className="title">
                    Congratulations!
                    <span className="text">
                      You Got a{" "}
                      {trialPlanData?.isTrial ? "Free Trial Plan" : "Plan"}
                    </span>
                  </h1>
                </div>
                <div className="plansWrap__list">
                  <SubscriptionPlanCard
                    plan={trialPlanData}
                    isCurrentPlan
                    isForFreeTrial
                  />
                </div>
                <button
                  className="btn btn__primary btn--full"
                  onClick={handleContinue}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StartFreeTrial;
